
( function( blocks, element, editor ) {
    var RichText = editor.RichText;
 
    blocks.registerBlockType( 'rollrasen-rudi/rudi-sagt', {
        title: 'Rudi sagt',
        description: 'Was sagt Rudi dazu?',
        category: 'common',
        icon: 'megaphone',

        attributes: {
            content: {
                type: 'array',
                source: 'children',
                selector: '.wp-block-gutenberg-content',
            },
        },

        edit: function(props) {
            var content = props.attributes.content;
            function onChangeContent( newContent ) {
                props.setAttributes( { content: newContent } );
            }

            return element.createElement(
                'div',
                { className: 'wp-block-gutenberg-wrapper'},
                [
                    element.createElement(
                        'div',
                        {className: 'wp-block-gutenberg-img-wrapper'},
                        element.createElement(
                            'img',
                            {
                                className: 'wp-block-gutenberg-img',
                                src: gutenberg_data.rudi_img_url,
                                alt: 'Rudi'
                            }
                        )
                    ),
                    element.createElement(
                        'p',
                        {className: 'wp-block-gutenberg-subheader'},
                        'Das sagt Rudi dazu:'
                    ),
                    element.createElement(
                        RichText,
                        {
                            className: 'wp-block-gutenberg-content',
                            tagName: 'p',
                            onChange: onChangeContent,
                            value: content
                        }
                    )
                ]
            );
        },

        save: function(props) {
            return element.createElement('div',
            { className: 'wp-block-gutenberg-wrapper'},
            [
                element.createElement(
                    'div',
                    {className: 'wp-block-gutenberg-img-wrapper'},
                    element.createElement(
                        'img',
                        {
                            className: 'wp-block-gutenberg-img',
                            src: gutenberg_data.rudi_img_url,
                            alt: 'Rudi'
                        }
                    )
                ),
                element.createElement(
                    'p',
                    {className: 'wp-block-gutenberg-subheader'},
                    'Das sagt Rudi dazu:'
                ),
                element.createElement(
                    RichText.Content,
                    {
                        tagName: 'p',
                        className: 'wp-block-gutenberg-content',
                        value: props.attributes.content
                    }
                )
            ]
            );
        },
    } );
}(
    window.wp.blocks,
    window.wp.element,
    window.wp.editor,
) );